import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NavigationBar from "../../components/Heritage/NavigationBar";
import { Link } from "react-router-dom";

const ancientBeautyData = [
  {
    name: "Kumkum & Sandalwood Tilak",
    image:
      "https://static.toiimg.com/thumb/imgsize-27518,msid-105289806,width-375,height-210,resizemode-75/105289806.jpg",
    description:
      "A spiritual and aesthetic forehead mark made from natural sandalwood or turmeric, used by both men and women since Vedic times.",
  },
  {
    name: "Ubtan (Herbal Face & Body Pack)",
    image:
      "https://cdn.shopify.com/s/files/1/0693/9620/1776/t/5/assets/aa0fdae45e01--ubtan-480x480-794f73.png?v=1691414918",
    description:
      "Made from turmeric, sandalwood, besan, rosewater – applied during weddings and daily routines to cleanse and glow the skin.",
  },
  {
    name: "Kajal / Surma",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSd5A8CJ1nTnGuXqzGyxB4HDHCMILjAbfmULw&s",
    description:
      "Natural eyeliner made from soot and ghee – used for eye protection, beauty, and enhancing expressions in classical dance.",
  },
  {
    name: "Hair Oils (Neeli, Bhringraj, Amla)",
    image:
      "https://rukminim2.flixcart.com/image/256/256/cms-rpd-img/31dc0ab344a14e899fdeeef74a4ef42c_18f61e3b541_Banner213.png?q=90",
    description:
      "Oils infused with Ayurvedic herbs like bhringraj, amla, brahmi to nourish hair, prevent greying, and promote calmness.",
  },
  {
    name: "Natural Dyes (Henna & Indigo)",
    image:
      "https://shop.cultivator.in/cdn/shop/articles/1_b0f1cd50-96ea-4c1c-a519-e94a3dc43dc1.jpg?v=1701231882",
    description:
      "Used for centuries to dye hair and hands – henna cools the body, while indigo adds deep black tones naturally.",
  },
  {
    name: "Rosewater & Kesar (Saffron) Tonics",
    image:
      "https://ishanayurved.com/wp-content/uploads/2023/10/Kesar-5-1024x743.jpg",
    description:
      "Used by queens and temple dancers to cleanse and tone the skin – a luxurious remedy for brightness and fragrance.",
  },
];

const Beauty = () => {
  return (
    <>
      <NavigationBar />
      <Container className="py-5">
        <h1 className="text-center fw-bold mb-4">
          Ancient Beauty Secrets of Bharat 🌿
        </h1>
        <p className="text-center text-muted mb-5">
          From temples to palaces, explore natural beauty rituals passed down
          through millennia.
        </p>

        <Row>
          {ancientBeautyData.map((item, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Link
                  to={`/heritage/beauty/${encodeURIComponent(item.name)}`}
                  state={{ beauty: item }}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.name}
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>{item.name}</Card.Title>
                    <Card.Text>{item.description}</Card.Text>
                  </Card.Body>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Ad Block */}
        <div className="bg-light border rounded text-center p-3 mt-4">
          <strong>Ad:</strong> Reclaim your skin’s glow with Ayurvedic beauty
          oils and Ubtan kits – Try Bharat’s royal secrets today!
        </div>
      </Container>
    </>
  );
};

export default Beauty;
